import { initBackend as initIndexedDB } from 'absurd-sql/dist/indexeddb-main-thread';

import { BlockchainWorker } from ':fat/messaging/entities/blockchainWorker';
import { DatabaseWorker } from ':fat/messaging/entities/databaseWorker';

export async function initializeWorkers() {
  const blockchainWorker = new Worker(new URL('./blockchain/worker', import.meta.url));
  const databaseWorker = new Worker(new URL('./database.worker', import.meta.url));

  initIndexedDB(databaseWorker);
  MessageBus.registerWorkers(blockchainWorker, databaseWorker);

  // Create a channel for the workers to communicate over
  const workerChannel = new MessageChannel();
  const { port1: blockchainWorkerPort, port2: databaseWorkerPort } = workerChannel;

  // Tell each worker how to communicate with the other
  await Promise.all([
    BlockchainWorker.actions.setup(databaseWorkerPort),
    DatabaseWorker.actions.setup(blockchainWorkerPort),
  ]);
}
